module.exports = __webpack_public_path__ + "img/normal_multiplier.b0dab430.png";